import { useGateValue } from '@statsig/react-bindings';

/** Settings > Quoting vendors: the sidebar entry and page. Target it with an
 * "Environment Tier = staging" rule to release to UAT only. The backend checks
 * the same gate on the vendor-connections routes. */
export const QUOTING_VENDORS_GATE = 'quoting_vendors_settings';

export function useQuotingVendorsGate(): boolean {
  return useGateValue(QUOTING_VENDORS_GATE);
}
